import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const ease = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function LineReveal({ lines = [], className = "" }) {
  return (
    <span className={className}>
      {lines.map((ln, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, ease, delay: 0.15 + i * 0.12 }}
          >
            {ln}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Overline({ children, className = "" }) {
  return <div className={`overline ${className}`}>{children}</div>;
}

export function ArrowLink({ to, children, testid }) {
  return (
    <Link to={to} className="link-arrow" data-testid={testid}>
      {children}
      <span aria-hidden>&rarr;</span>
    </Link>
  );
}
